"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Captcha = _interopRequireDefault(require("@/components/Captcha"));
var _default = exports.default = {
  components: {
    Captcha: _Captcha.default
  },
  props: ['buffer', 'network'],
  data() {
    return {
      forceLoader: false
    };
  },
  computed: {
    netStatus() {
      return this.buffer.getNetwork().state;
    },
    shouldShowLoading() {
      this.maybeForceLoader();
      if (this.network.state !== 'disconnected' || this.forceLoader) {
        return true;
      }
      return false;
    },
    restrictedServer() {
      return this.$state.setting('restricted');
    },
    readyToStart() {
      return true;
    }
  },
  methods: {
    maybeForceLoader() {
      // The connection can fail almost imediately making it look like
      // the connection attempt didn't try anything. Make the connection
      // loder stay visible for at elast X seconds to indicate it's actually
      // tried something.
      let minimumLoaderViewtime = 2000;
      let networkState = this.network.state;
      if (networkState !== 'disconnected' && !this.forceLoader) {
        this.forceLoader = true;
        setTimeout(() => {
          this.forceLoader = false;
        }, minimumLoaderViewtime);
      }
    },
    isChannel() {
      return this.buffer.isChannel();
    },
    isServer() {
      return this.buffer.isServer();
    },
    isQuery() {
      return this.buffer.isQuery();
    },
    reconnect() {
      if (!this.readyToStart) {
        return;
      }
      if (this.buffer.isChannel()) {
        this.buffer.enabled = true;
      }
      this.buffer.getNetwork().ircClient.connect();
    },
    showNetworkSettings() {
      let network = this.buffer.getNetwork();
      network.showServerBuffer('settings');
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["NotConnected"]
window._app_exports.components.NotConnected = exports.default ? exports.default : exports;
